import React, { useEffect } from "react";
import {
  FilterWrapper,
  StyledMenu
} from "../../../../../../CommonComponents/TabsComponent/styles";
import { DisplayFlex } from "../../../../../../CommonComponents/commonStyles";
import funnel from "../../../../../../assets/icons/Funnel.png";
import MultiSelect from "../Exchanges/Select";
import { connect } from "react-redux";
import { DropdownList } from "../../style";
import { PropTypes } from "prop-types";

const AdvancedSearch = props => {
  const { tab } = props;
  useEffect(() => {
  }, [tab]);


  return (
    <>
      <Brain
        handleSearch={props.handleSearch}
        menu={props.menu}
        startDate={props.startDate}
        endDate={props.endDate}
        tab={tab}
        render={({ handleYearly, handleStatus, handleFrequency, tab }) => (
          <div>
            <DisplayFlex
              style={{ overflow: "scroll", justifyContent: "flex-end" }}
            >
              {
                <FilterDropdown
                  tab={tab}
                  menu={props.menu}
                  handleStatus={handleStatus}
                  handleFrequency={handleFrequency}
                  handleYearly={handleYearly}
                  oneTimeStatus={props.oneTimeStatus}
                  recurringStatus={props.recurringStatus}
                />
              }
            </DisplayFlex>
          </div>
        )}
      />
    </>
  );
};

class Brain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "",
      frequency: "",
      yearly: ""
    };
    this.handleYearly = this.handleYearly.bind(this);
    this.handleFrequency = this.handleFrequency.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
  }

  handleStatus = value => {
    const status = value;
    this.setState({ status }, () => this.props.handleSearch(this.state));
  };

  handleFrequency = value => {
    const frequency = value;
    let isOneTime = this.props.tab == 1 ? true : false;
    let isRecurring = this.props.tab == 2 ? true : false
    this.setState({ frequency }, () => this.props.handleSearch(this.state, isOneTime, isRecurring));
  };

  handleYearly = yearly => {
      let isOneTime = this.props.tab == 1 ? true : false;
      let isRecurring = this.props.tab == 2 ? true : false
    this.setState({ yearly }, () => this.props.handleSearch(this.state, isOneTime, isRecurring));
  };

  componentDidUpdate(prevProps) {
    if (this.props.tab !== prevProps.tab) {
      this.setState({ status: [], frequency: [], yearly: [] });
    }
  }

  render() {
    return this.props.render({
      state: this.state,
      handleYearly: this.handleYearly,
      handleFrequency: this.handleFrequency,
      handleStatus: this.handleStatus,
      tab: this.props.tab
    });
  }
}

const FilterDropdown = props => {
  const filters = (
    <>
      <StyledMenu>
        <StatusFilter
          handleDropper={props.handleStatus}
          menu={props.menu}
          tab={props.tab}
          id="selStatusFilter"
          oneTimeStatus={props.oneTimeStatus}
          recurringStatus={props.recurringStatus}
        />
        <div style={{ height: 20 }} />
        <YearlyFilter
          handleDropper={props.handleYearly}
          menu={props.menu}
          tab={props.tab}
          id="selYearlyFilter"
        />
        {props.tab == 2 && (
          <div>
            <div style={{ height: 20 }} />
            <FrequencyFilter
              tab={props.tab}
              handleDropper={props.handleFrequency}
              menu={props.menu}
              id="selFrequencyFilter"
            />
          </div>
        )}
      </StyledMenu>
    </>
  );
  return (
    <>
      <DropdownList
        overlayClassName="exchange-dropDown"
        id="selexchangedropDown"
        overlay={filters}
        style={{ marginLeft: "-40px" }}
      >
        <FilterWrapper>
          Filter
          <img src={funnel} alt="filter" style={{ marginLeft: 10 }} />
        </FilterWrapper>
      </DropdownList>
    </>
  );
};

const StatusFilter = props => {
  const {recurringStatus, oneTimeStatus} = props;
  return (
    <DisplayFlex
      style={{ justifyContent: "space-between", alignItems: "center" }}
    >
      <div style={{ marginRight: 10 }}>Status:</div>
      {props.menu.statusGrantFilters && (
        <MultiSelect
          id="selFilterbyStatus1"
          options={(oneTimeStatus.length > 0 )? oneTimeStatus : props.menu.statusGrantFilters}
          placeholder={"Filter by Status"}
          handleDropper={props.handleDropper}
          tab={props.tab}
        />
      )}
      {props.menu.recurringGrantFilters && (
        <MultiSelect
          id="selFilterbyStatus2"
          options={(recurringStatus.length > 0 ) ? recurringStatus : props.menu.recurringGrantFilters}
          placeholder={"Filter by Status"}
          handleDropper={props.handleDropper}
          tab={props.tab}
        />
      )}
    </DisplayFlex>
  );
};

const YearlyFilter = props => {
  return (
    <DisplayFlex
      style={{ justifyContent: "space-between", alignItems: "center" }}
    >
      <div style={{ marginRight: 10 }}>Yearly:</div>
      {props.tab == 1 && props.menu.yearlyGrantFilters && (
        <MultiSelect
          id="selFilterbyYear1"
          options={props.menu.yearlyGrantFilters}
          placeholder={"Filter by Year"}
          handleDropper={props.handleDropper}
          tab={props.tab}
        />
      )}
      {props.tab == 2 && props.menu.yearlyGrantFilters && (
        <MultiSelect
          id="selFilterbyYear2"
          options={props.menu.yearlyGrantFilters}
          placeholder={"Filter by Year"}
          handleDropper={props.handleDropper}
          tab={props.tab}
        />
      )}
    </DisplayFlex>
  );
};

const FrequencyFilter = props => {
  return (
    <DisplayFlex
      style={{ justifyContent: "space-between", alignItems: "center" }}
    >
      <div style={{ marginRight: 10 }}>Frequency:</div>
      {props.tab == 2 && props.menu.frequencyGrantFilters && (
        <MultiSelect
          id="selFilterbyFrequency"
          options={props.menu.frequencyGrantFilters}
          placeholder={"Filter by Frequency"}
          handleDropper={props.handleDropper}
          tab={props.tab}
        />
      )}
    </DisplayFlex>
  );
};

const mapStateToProps = state => ({
  tab: state.getIn(["exchangeActivity", "tab"])
});
AdvancedSearch.propTypes = {
  tab: PropTypes.number,
  handleSearch:PropTypes.func,
  oneTimeStatu:PropTypes.array,
  recurringStatus:PropTypes.array,
};

export default connect(
  mapStateToProps,
  null
)(AdvancedSearch);
